module.exports = __webpack_public_path__ + "img/snapchat.10dc122c.webp";